import { createMarkup } from '../../helpers/markup'
import StickyFooter from './StickyFooter'
import themeConfig from '../../../theme.config'
import BackToTop from './BackToTop'
import { lightOrDark } from '../../helpers/style'

function Footer(props) {
  const bgSplit = themeConfig.settings.nav.footer.base.split('-')

  return (
    <>
      <footer
        style={{
          '--bg-color': themeConfig.settings.nav.footer.base ?? '#fff',
          '--light-or-dark': lightOrDark(themeConfig.settings.nav.footer.base),
        }}
        className={`px-6 py-16 grid gap-8 text-center bg-[color:var(--bg-color)] text-${lightOrDark(themeConfig.settings.nav.footer.base)}`}
      >
        {props.footerNavigationItems?.length > 0 && (
          <div className="footer-nav flex flex-wrap mb-8 justify-center lg:justify-start gap-12 lg:gap-0 lg:gap-y-12">
            {props.footerNavigationItems.map((col, idx) => (
              <nav className="basis-full lg:basis-[calc(100%_/_6)] lg:min-w-[25ch]" aria-label={col.title ?? `Footer nav column ${idx + 1}`} data-text>
                {col.title && <h3 className="text-xl text-start p-1 mx-1 my-0">{col.title}</h3>}
                <ul>
                  {col.footerNavigationItems?.length > 0 &&
                    col.footerNavigationItems?.map((link, j) => (
                      <>
                        {link.url && (
                          <li  data-rte={themeConfig.settings.nav.footer.inheritLinkStyle.toString()} className='text-start'>
                            <a
                              key={`footer-nav-item-${j}`}
                              href={link.url}
                              data-index={j}
                              data-has-title={`${col.title && col.title.length ? 'true' : 'false'}`}
                              target={link.target ? link.target : '_self'}
                            >
                              {link.label}
                            </a>
                          </li>
                        )}
                      </>
                    ))}
                </ul>
              </nav>
            ))}
          </div>
        )}
        {props.footerDescription && (
          <div className="max-w-[590px] mx-auto flex items-start  pt-2">
            <div data-rte="true" dangerouslySetInnerHTML={createMarkup(props.footerDescription)} />
          </div>
        )}
        {props.socialMediaLinks?.length ? (
          <ul className="flex mx-auto justify-center w-3/5 gap-10 justify-center">
            {props.socialMediaLinks?.map((link, j) => (
              <li key={j}>
                <a
                  href={link.link?.url}
                  target="_blank"
                  title={link.link?.name}
                  className="block w-[24px] border-b-2 transition-all duration-500 border-transparent hover:border-[currentColor] pb-1 group"
                >
                  <img
                    className="w-full h-auto group-hover:scale-[1.1] transition-all duration-500"
                    alt=""
                    src={link.linkImage?.src}
                  />
                  <span class="sr-only">{link.link?.name}</span>
                </a>
              </li>
            ))}
          </ul>
        ) : null}
        <div className="max-w-2xl text-balance mx-auto text-xs ">
          &copy; Copyright {new Date().getFullYear()}{' '}
          <div data-rte="true" dangerouslySetInnerHTML={createMarkup(props.copyrightText)} />
        </div>
        {props.footerDisclaimerText && (
          <div className="max-w-2xl mx-auto text-balance text-xs flex items-start  pt-2">
            <div data-rte="true" dangerouslySetInnerHTML={createMarkup(props.footerDisclaimerText)} />
          </div>
        )}
        <BackToTop />
      </footer>
      {!props.disableSticky && (props.stickyNavPrimary || props.stickyNavSecondary) && <StickyFooter {...props} />}
    </>
  )
}

export default Footer
